import { FC, PropsWithChildren, ReactElement } from 'react';
import { Stack } from '@mui/system';
import { InfoTranslateionSlots, InfoTranslationsVariant, useInfoTranslations } from '../model';
import { Tooltip } from '../../tooltip';
import { Typography } from '../../typography';
import { useTheme } from '../../../hooks';

export const InfoTooltip: FC<PropsWithChildren<InfoTranslateionSlots>> = ({ translations, children }) => {
  const theme = useTheme();
  const translation = useInfoTranslations(translations);

  return (
    <Tooltip
      placement="bottom-end"
      sx={{
        '.MuiTooltip-tooltip': {
          color: theme.palette['brand gray'],
          background: theme.palette['gray light'],
        },
      }}
      title={
        <Stack spacing={0.4} sx={{ padding: '6px 12px 8px' }}>
          {translation(InfoTranslationsVariant.title, ({ value }) => (
            <Typography variant="body bold">{value}</Typography>
          ))}
          {translation(InfoTranslationsVariant.info, ({ value }) => (
            <Typography variant="caption">{value}</Typography>
          ))}
        </Stack>
      }
    >
      {children as ReactElement}
    </Tooltip>
  );
};
